// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1EKh4","col":"CardReaderDesc_col__3h_7w","label":"CardReaderDesc_label__1io19"};